import React, { useContext, useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import HeaderNav from "../../_nav";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/header/logo.png";
import logout from "../../assets/images/header/logout.png";
import notification from "../../assets/images/header/notification.png";
import user from "../../assets/images/header/user.png";
import User_Management_Modal from "../header_components/user_management_modal/User_Management_Modal";
import Profile_Offcanvas from "../header_components/profile_offcanvas/Profile_Offcanvas";
import Notifications from "../header_components/notifications/Notifications";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { GETAuthLogin } from "../../features/auth/Slice";
import Logout_Confirmation_Modal from "../../common/common_modal/logout_confirmation_modal/Logout_Confirmation_Modal";

const Header = () => {
  const dispatch = useDispatch();

  const userPermissions = useSelector((state) => state.auth.permissions);

  const user = useSelector((state) => state.auth.data);

  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);

  const normalizePermissions = (permission_ids) => {
    if (!permission_ids) return [];
    return Array.isArray(permission_ids) ? permission_ids : [permission_ids];
  };

  const hasPermission = (nav) => {
    const required = normalizePermissions(nav?.permission_ids);
    if (required.length === 0) return true;
    return required.some((id) => userPermissions?.includes(id));
  };

  const navigate = useNavigate();
  const [viewNotification, setNotificationView] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const [showUserModal, setShowUserModal] = useState(false);
  const [showProfileOffcanvas, setShowProfileOffcanvas] = useState(false);
  const [logout_modal, setLogout_modal] = useState(false);

  const handleLogout = () => {
    setLogout_modal(true);
  };

  const isActive = (nav) => {
    return (
      currentPath === nav?.path ||
      currentPath.startsWith(nav?.path + "/") ||
      (nav?.activeBase && currentPath.startsWith(nav.activeBase))
    );
  };
  return (
    <section className="Header">
      <div className="container-fluid p-0">
        <div className="top_section">
          <Link to={"/dashboard"}>
            <div className="logo_holder">
              <img src={logo} className="logo_img" />
            </div>
          </Link>

          <div className="right_side">
            <div className="img_text_div" onClick={handleLogout}>
              <img src={logout} className="inner_img" />
              <p className="inner_text">Logout</p>
            </div>

            <div
              className="img_text_div"
              onClick={() => setNotificationView(true)}
            >
              <img src={notification} className="inner_img" />
              <p className="inner_text">Notification</p>
            </div>

            <div
              className="img_text_div"
              onClick={() => {
                setShowProfileOffcanvas(true);
              }}
            >
              <img src={user} className="inner_img" />
              <p className="inner_text">Profile</p>
              <FontAwesomeIcon icon={faSortDown} className="inner_icon" />
            </div>
          </div>
        </div>

        <div className="all_navs_holder">
          <Swiper
            spaceBetween={16}
            slidesPerView={2}
            breakpoints={{
              0: { slidesPerView: 2.1, spaceBetween: 5 },
              450: { slidesPerView: 3, spaceBetween: 10 },
              450: { slidesPerView: 3.5, spaceBetween: 10 },
              576: { slidesPerView: 4.1, spaceBetween: 10 },
              768: { slidesPerView: 4.1, spaceBetween: 10 },
              992: { slidesPerView: 6, spaceBetween: 10 },
              1200: { slidesPerView: 7.5, spaceBetween: 10 },
              1400: { slidesPerView: 7.5, spaceBetween: 10 },
              1600: { slidesPerView: 10, spaceBetween: 10 },
            }}
          >
            {/* {HeaderNav?.map((nav, index) => { */}
            {HeaderNav?.filter((nav) => hasPermission(nav)).map(
              (nav, index) => {
                console.log("HeaderNav", nav?.path);
                // console.log(nav.name, nav.permission_ids, hasPermission(nav));

                const handleNavClick = (e) => {
                  if (nav?.path === "/user-management-modal") {
                    e.preventDefault();
                    setShowUserModal(true);
                  }
                };

                return (
                  <SwiperSlide key={index}>
                    <Nav.Link
                      as={Link}
                      to={nav?.path}
                      onClick={handleNavClick}
                      // className={
                      //   currentPath === nav?.path ||
                      //   currentPath.startsWith(nav?.path + "/")
                      //     ? "active"
                      //     : ""
                      // }
                      className={isActive(nav) ? "active" : ""}
                    >
                      <div className="nav_div">
                        <div className="nav_img_div">
                          <img
                            src={process.env.PUBLIC_URL + nav?.img}
                            className="nav_img"
                            alt={nav?.name}
                          />
                        </div>
                        <p className="nav_text">
                          {nav.name.split("\n").map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))}
                        </p>
                      </div>
                    </Nav.Link>
                  </SwiperSlide>
                );
              },
            )}
          </Swiper>
        </div>
      </div>

      <User_Management_Modal
        show={showUserModal}
        onHide={() => setShowUserModal(false)}
        btnText={"Submit"}
      />
      <Profile_Offcanvas
        setShowProfileOffcanvas={setShowProfileOffcanvas}
        show={showProfileOffcanvas}
        handleClose={() => setShowProfileOffcanvas(false)}
      />
      <Notifications
        show={viewNotification}
        handleClose={() => setNotificationView(false)}
      />

      <Logout_Confirmation_Modal
        modalHeadingText={"Are you sure you want to logout?"}
        show={logout_modal}
        onHide={() => {
          setLogout_modal(false);
        }}
      />
    </section>
  );
};

export default Header;
